import { useTranslation } from "react-i18next";

const PageSwitcher = ({ currentPage, totalPages, activitiesAmount, handlePageClick }) => {
    const {t} = useTranslation();
    return (
        <div className="w-full flex gap-2 justify-center items-center my-8">
            <div className="flex flex-col gap-2">

                <div className="flex justify-center text-slate-400">
                    {t('AllActivities.PageSwitcher.totalPages')} {totalPages}
                </div>

                <div className="flex gap-2">
                    {/* LEFT ARROW */}
                    <div className={`w-[40px] h-[50px] flex justify-center items-center pb-1.5 cursor-pointer text-xl`} onClick={() => handlePageClick(1)}>
                        <i className="fi fi-br-angle-double-right rotate-180 text-[#225424]"></i>
                    </div>
                    <div className={`w-[40px] h-[50px] flex justify-center items-center p-3 rounded cursor-pointer ${currentPage !== 1 && 'border'}`} onClick={() => currentPage !== 1 && handlePageClick(currentPage - 1)}>
                        {currentPage !== 1 && currentPage - 1}
                    </div>
                    <div className="w-[40px] h-[50px] flex justify-center items-center p-3 rounded text-slate-400">
                        {currentPage}
                    </div>
                    <div className={`w-[40px] h-[50px] flex justify-center items-center p-3 rounded cursor-pointer ${currentPage !== totalPages && 'border'}`} onClick={() => currentPage !== totalPages && handlePageClick(currentPage + 1)}>
                        {currentPage !== totalPages && currentPage + 1}
                    </div>
                    {/* RIGHT ARROW */}
                    <div className={`w-[40px] h-[50px] flex justify-center items-center pt-1.5 cursor-pointer text-xl`} onClick={() => handlePageClick(totalPages)}>
                        <i className="fi fi-br-angle-double-right text-[#225424]"></i>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default PageSwitcher;